import React from "react";

interface ChildsProps {
    latitude: number;
    longitude: number;
}

const AbrirUbicacion: React.FC<ChildsProps> = ({latitude, longitude}) => {
    const URL_GOOGLE_MAPS = "https://www.google.com/maps/search/?api=1&query=";
    return(
        <a target="_blank" rel="noreferrer" href={`${URL_GOOGLE_MAPS}${latitude},${longitude}`}>
            <button className="btn btn-primary mb-3">
                Abrir Ubicación
            </button>
        </a>
    )
}

export default AbrirUbicacion;